export default __webpack_public_path__ + "static/media/logo.49277a26.svg";